export default __webpack_public_path__ + "a7aa986c9393eaefb92f7256311a304c.png";